import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";

const AddHelpLine = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [isError, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formValue, setFormValue] = useState({
        id: null,
        name: "",
        phone_number: "",
    });

    const saveSize = () => {
        if (formValue.name &&
            formValue.phone_number
        ) {
            setError(false);
            setLoading(true);
            const pUrl = id ? API_URL.HELPLINE_UPDATE : API_URL.HELPLINE_SAVE;
            axios
                .post(pUrl, formValue)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === 1) {
                        let message = id
                            ? "HelpLine Updated Successfully."
                            : "HelpLine Created Successfully.";
                        toast.success(message, { autoClose: 3000, position: "top-right" });
                        setLoading(false);
                        navigate("/settings/help-line");
                    }
                })
                .finally(() => {
                    setLoading(false);
                    setError(true);
                });
        } else {
            setLoading(false);
            setError(true);
        }
    };

    const onEdit = () => {
        axios.post(API_URL.HELPLINE_GET, { id: id }).then((res) => {
            if (res.data.status === 1) {
                setFormValue({
                    id: res.data.data.id,
                    name: res.data.data.name ? res.data.data.name : "",
                    phone_number: res.data.data.phone_number ? res.data.data.phone_number : "",
                });
            }
        });
    };
    const isRequiredField = (key) => {
        return isError && !formValue[key];
    };


    useEffect(() => {
        id && onEdit();
    }, [id]);

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} HelpLine</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/settings/help-line"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={(event) => event.preventDefault()}>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Name<span className="required-star">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formValue.name}
                                                className={
                                                    isRequiredField("name")
                                                        ? "form-control required"
                                                        : "form-control"
                                                }
                                                id="name"
                                                onChange={(event) => {
                                                    setFormValue({
                                                        ...formValue,
                                                        name: event.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>
                                                Phone No.<span className="required-star">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                name="name"
                                                value={formValue.phone_number}
                                                className={
                                                    isRequiredField("phone_number")
                                                        ? "form-control required"
                                                        : "form-control"
                                                } id="phone_number"
                                                onChange={(event) => {
                                                    setFormValue({
                                                        ...formValue,
                                                        phone_number: event.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group text-right">
                                        <button
                                            type="submit"
                                            onClick={saveSize}
                                            // disabled={loading}
                                            className="btn btn-primary"
                                        >
                                            {loading ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Watch color={"white"} height={20} width={20} />
                                                </div>
                                            ) : (
                                                "Save"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddHelpLine;
